<template>
  <BaseDialog
    :isOpen="true"
    :width="1200"
    :fullscreen="isMobile"
    @close="close"
  >
    <template v-slot:title>
      Add Experience
    </template>
    <template v-slot:body>
      <ExperienceDetailsForm
        :class="{ container: isMobile }"
        ref="experienceDetailsForm"
      />
    </template>
    <template v-slot:actions>
      <PrimaryButton
        @click.native="close"
        text
        :disabled="isLoading"
        v-if="!isMobile"
      >
        Cancel
      </PrimaryButton>
      <PrimaryButton @click.native="onSubmit" :loading="isLoading">
        Save Changes
      </PrimaryButton>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import ExperienceDetailsForm from "@/views/profile/QuestionsAndAnswers/steps/Experience/components/ExperienceDetailsForm";
import { EXPERIENCE_NAMESPACE } from "@/store/modules/users/experience";
import { createNamespacedHelpers } from "vuex";
import { ADD_USER_EXPERIENCE } from "@/store/modules/users/experience/actions";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import { BASE_DATE_FORMAT, API_DATE_FORMAT } from "@/constants/common";
import { formatDate } from "@/utils/time";

const { mapActions } = createNamespacedHelpers(EXPERIENCE_NAMESPACE);
const { mapState: mapAuthState } = createNamespacedHelpers(AUTH_NAMESPACE);

export default {
  name: "AddExperienceDialog",
  components: {
    PrimaryButton,
    BaseDialog,
    ExperienceDetailsForm
  },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    ...mapAuthState({
      self: state => state.userData
    })
  },
  methods: {
    ...mapActions({
      addUserExperience: ADD_USER_EXPERIENCE
    }),
    close() {
      this.$emit("close");
    },
    async onSubmit() {
      const isValid = await this.$refs.experienceDetailsForm.validate();
      if (isValid) {
        const newExperienceData = this.$refs.experienceDetailsForm.getData();
        this.isLoading = true;
        await this.addUserExperience({
          ...newExperienceData,
          startDate: formatDate({
            date: newExperienceData.startDate,
            startFormat: BASE_DATE_FORMAT,
            endFormat: API_DATE_FORMAT
          }),
          endDate: formatDate({
            date: newExperienceData.endDate,
            startFormat: BASE_DATE_FORMAT,
            endFormat: API_DATE_FORMAT
          }),
          user: {
            id: this.self.id,
            type: "users"
          }
        });
        this.close();
        this.$refs.experienceDetailsForm.clearForm();
        this.isLoading = false;
      }
    }
  }
};
</script>

<style lang="scss"></style>
